/**
 * Centralised logger.
 *
 * Default sink is `console` (dev). Phase 13 swaps the sink for an AppInsights
 * adapter so production errors become trackException calls automatically.
 *
 * No `console.*` calls should remain in app code outside this module.
 */
export interface LoggerSink {
  debug(msg: string, ...args: unknown[]): void;
  info(msg: string, ...args: unknown[]): void;
  warn(msg: string, ...args: unknown[]): void;
  error(msg: string, ...args: unknown[]): void;
}

/* eslint-disable no-console */
const consoleSink: LoggerSink = {
  debug: (m, ...a) => console.debug(m, ...a),
  info: (m, ...a) => console.info(m, ...a),
  warn: (m, ...a) => console.warn(m, ...a),
  error: (m, ...a) => console.error(m, ...a),
};
/* eslint-enable no-console */

let currentSink: LoggerSink | null = null;

export const setLoggerSink = (sink: LoggerSink | null): void => {
  currentSink = sink;
};

const active = (): LoggerSink => currentSink ?? consoleSink;

export const logger: LoggerSink = {
  debug: (m, ...a) => active().debug(m, ...a),
  info: (m, ...a) => active().info(m, ...a),
  warn: (m, ...a) => active().warn(m, ...a),
  error: (m, ...a) => active().error(m, ...a),
};
